<template>    
    <v-container fluid  class="main">
      <LeftMenu/>  
       <v-layout row wrap>  
           <Progress :show="this.showProgress" />
           <v-flex xs1></v-flex>
            <v-flex xs11>
                <v-row
                    class="mb-6"
                    no-gutters
                >
                    <v-col md="7" class="pa-2" >
                        <v-layout wrap>
                            <v-flex xs12 sm6 md6>
                                <v-combobox                                                               
                                    :items="saleList"
                                    label="Select Sale"
                                    v-model="workOrder.sale"
                                    item-text="saleText"
                                    single-line                                
                                    return-object
                                ></v-combobox>
                            </v-flex>
                            <v-flex xs12 sm6 md1/>
                            <v-flex xs12 sm6 md3>
                                <v-combobox	
                                    :items="personnels"	
                                    label="Select Assignee"	
                                    v-model="workOrder.assignee"	
                                    item-text="name"	
                                    single-line	
                                    return-object>	
                                </v-combobox>	
                            </v-flex> 
                            
                            <v-flex xs12 sm6 md2>
                                
                            </v-flex>


                            <v-flex xs12 sm6 md3>
                                <DatePicker picker-label="Start Date" :date-value="workOrder.startDate" @dateSelected="workOrder.startDate=$event" />                              
                            </v-flex>  
                            <v-flex xs12 sm6 md1/>
                            <v-flex xs12 sm3 md3 >
                                <DatePicker picker-label="Planned End Date" :date-value="workOrder.plannedEndDate" @dateSelected="workOrder.plannedEndDate=$event" /> 
                            </v-flex>                   
                            <v-flex xs12 sm6 md1>
                            </v-flex> 
                            <v-flex xs12 sm6 md3>
                                                           
                            </v-flex>  
                            <v-flex xs12 sm6 md1/>   


                            <v-flex xs12 sm6 md3>	
                                
                            </v-flex> 
                            <v-flex xs12 sm6 md1/>
                            <v-flex xs12 sm6 md4/>
                            <v-flex xs12 sm6 md3>
                               
                            </v-flex> 
                            <v-flex xs12 sm6 md1/>

                            <v-flex xs12 sm6 md11>
                                <v-textarea v-model="workOrder.explanation"  :outlined="true"
                                :auto-grow="true" :clearable="true"
                                label="Explanation"></v-textarea>
                            </v-flex>   
                            <v-flex xs12 sm6 md11/>
                        </v-layout>
                    </v-col>
                    <v-col md="5" class="pa-2" >
                        
                            <v-layout row wrap>                                         
                                <v-flex xs12 >
                                    <Documents :documents="this.workOrder.documents" master-category="OFFER" :folder-id="this.workOrder.folderId"
                                               :parentRecord="this.workOrder.id" :readonly="true" @documentsChanged="getWorkOrder" />
                                </v-flex>                                            
                            </v-layout>      
                    </v-col>
                </v-row>
                <v-row
                    class="mb-6"
                    no-gutters
                >
                    <v-col md="7" class="pa-2" >
                        <v-layout wrap >   
                            <v-flex v-if="workOrder.id" xs12 sm6 md6>
                                <v-combobox
                                :items="materialList"
                                label="Select Material"
                                v-model="newMaterial.material"
                                item-text="materialName"     
                                item-value="id"       
                                v-on:change="materialSelected"                     
                                chips
                                return-object
                                ></v-combobox>
                            </v-flex>   
                            <v-flex v-if="workOrder.id" xs12 sm6 md1>
                                <v-text-field v-model="newMaterial.quantity"   label="Quantity"></v-text-field>
                            </v-flex>
                            
                            <v-flex v-if="workOrder.id" xs12 sm6 md2>
                                <v-currency-field :key="newMaterial.id" v-model="newMaterial.price"   label="Price"></v-currency-field>
                            </v-flex>
                            <v-flex v-if="workOrder.id" xs12 sm6 md2>                              
                                <v-btn v-if="isWorkOrderEditable(workOrder)" color="primary" dark class="mb-2" @click="addMaterial(workOrder)">Add To Work Order</v-btn>
                            </v-flex> 
                    
                            
                            <v-flex v-if="workOrder.id && loaded" xs12 sm6 md12>
                                <v-data-table
                                    :key="materialTableKey"
                                    :headers="materialHeaders"
                                    :items="workOrderMaterialList"
                                    item-key="material.id"
                                    sort-by="material.materialName"                                    
                                    class="elevation-1"
                                    hide-default-footer
                                    >
                                <template v-slot:item.materialAction="{ item }">                                                  
                                    <v-icon   
                                    :disabled="!isWorkOrderEditable(workOrder)"                                 
                                    @click="deleteMaterial(item)"
                                    >
                                    mdi-delete
                                    </v-icon>
                                </template>
                                </v-data-table>
                            </v-flex>  
                            <v-spacer></v-spacer>
                            <v-flex xs12 sm6 md7></v-flex> 
                            <v-flex xs12 sm6 md3>
                            </v-flex>  
                            <v-flex xs12 sm6 md2 >
                            </v-flex>  
                            <v-flex xs12 sm6 md12 > &nbsp;</v-flex>
                            <v-flex xs12 sm6 md10 />
                            <v-flex xs12 sm6 md2>
                                <v-btn v-if="isWorkOrderEditable(workOrder)" color="success" dark class="mb-2" @click="save">Save Work Order</v-btn>   
                            </v-flex> 
                        </v-layout>
                    </v-col>
                    <v-col md="5" class="pa-2" >
                        <v-layout wrap >   
                                <v-flex v-if="workOrder.id && loaded" xs12 sm6 md12>
                                    <v-data-table
                                        :key="id"
                                        :headers="workOrderDeliveriesHeaders"
                                        :items="workOrder.deliveries"
                                        item-key="id"
                                        sort-by="deliveryDate"                                    
                                        class="elevation-1"
                                        hide-default-footer
                                        >
                                        <template v-slot:top>
                                            <v-toolbar flat color="white">
                                                <v-toolbar-title>Deliveries</v-toolbar-title>
                                            </v-toolbar>
                                        </template>    
                                        <template v-slot:item.goToDetails="{ item }">              
                                            <v-icon                  
                                            @click="goToDetails(item)">
                                            mdi-send
                                            </v-icon>                
                                        </template> 
                                    </v-data-table>
                                </v-flex>  
                            <v-spacer></v-spacer>
                        
                        </v-layout>     
                    </v-col>
                </v-row>
            </v-flex>
       </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
import Progress from '../../components/Progress';
import Documents from '../../views/Documents';
import breadcrumbs from '../../store/breadcrumbs.js'
import formatPrice from '../../helpers/formatter';
import getTwoYearsBeforeStart from '../../helpers/getTwoYearsBeforeStart';
import getCurrentDate from '../../helpers/getCurrentDate';
const WORK_ORDER_API_URL = 'manufacture/workOrders';
const SALES_API_URL = 'sales'
const PERSONNEL_API_URL = 'definitions/personnelReduced';
const MATERIALS_API_URL = 'definitions/materials';
export default {
    props: {
    },
    components:{
      LeftMenu,
      DatePicker,
      Documents,
      Progress
    },
    data () {
      return {
        loaded: false,
        showProgress : false,
        saleList: [],
        salesStartDate: '',
        salesEndDate: '',
        workOrder : {},
        materialTableKey : 0,
        deliveriesTableKey : 0,
        materialList:[],
        personnels: [],
        newMaterial:{}
      }
    },
    computed: {      
        materialHeaders(){
            return [   
                { text: 'Material',  value: 'material.materialName'  },      
                { text: 'Work Order',  value: 'workOrderdQuantity', align: 'center'  },
                { text: 'Delivered',  value: 'deliveredQuantity', align: 'center'  },
                { text: 'Price(' + this.workOrder.currency.code +')',  value: 'priceFormatted' , align: 'right' }, 
                { text: 'Actions', value: 'materialAction', sortable: false },
            ]
        },
        workOrderDeliveriesHeaders(){
            return [   
                { text: '',align: 'left',sortable: false,value: 'goToDetails'},
                { text: 'Date',  value: 'deliveryDate'  },      
                { text: 'Supplier',  value: 'supplier.name'  }, 
            ]
        },
        currencyListWithText(){
            return this.currencyList.map((item) => {
                return {
                code: item.code,
                text: item.code+' - '+item.text          
                };
            })
        },
        workOrderMaterialList(){
            return this.workOrder.materials.map((item) => {
                var deliveredItemList = this.workOrder.deliveries.filter(x => x.materials && x.materials.filter(y => y.material.id == item.id).length > 0 );

                var deliveredItemQuantity = 0;
                if(deliveredItemList && deliveredItemList.length>0){

                    var arrayLength = deliveredItemList.length;
                    for (var i = 0; i < arrayLength; i++) {
                        var delivery = deliveredItemList[i];
                        if(delivery.materials){
                            for (var j = 0; j < delivery.materials.length; j++) {
                                deliveredItemQuantity += delivery.materials[j].quantity;
                            }
                        }
                    }
                }
                item.workOrderdQuantity = item.quantity;
                item.deliveredQuantity = deliveredItemQuantity;

                return item;    
            })
        }
    },
    created () {
        if(this.$route.params.id != 'new'){
            this.getWorkOrder(); 
        }else{
            this.workOrder.id= 0;
            this.workOrder.status = "NEW";
            this.workOrder.supplier = {};
            let currentSupplier = breadcrumbs.getters.getSupplier;
            let crumbs = breadcrumbs.getters.getBreadCrumps;
            if( crumbs && crumbs.length>0 && currentSupplier){
                this.workOrder.supplier = currentSupplier;
            }
        }
        this.salesStartDate = getTwoYearsBeforeStart();
        this.salesEndDate = getCurrentDate();
        this.getSalesByInterval(this.salesStartDate, this.salesEndDate);
        this.getPersonnels();
        this.getMaterialList();
        this.newMaterial = {}; 
    },
    methods: {
        async getWorkOrder(){
          this.$axios.get(this.$apiurl + WORK_ORDER_API_URL+'/'+ this.$route.params.id)
            .then(response => {
                this.workOrder = response.data;
                this.updateBreadCrumbs(response.data);
            }) 
            .catch(error => {
                console.log(error);
            });   
            //await this.getWorkOrderDeliveries();
        },
        goToDetails(item){
            this.$router.push('/deliveries/'+item.id);
        },
        isWorkOrderEditable(workOrder){
            return workOrder.status=='NEW' || workOrder.status=='OPEN';
        },
        getSalesByInterval(startDate, endDate){
            this.$axios.get(this.$apiurl + SALES_API_URL, { 
                    params: {
                    startDate: startDate,
                    endDate: endDate,
                    showUnpaid: true
                    }                                               
                })
                .then(response => {
                    this.saleList = response.data.saleList
                }) 
                .catch(error => {
                    console.log(error);
                });  
            },  
        save () {
            if(!this.workOrder.sale || !this.workOrder.sale.id){
                alert('Sale cannot be empty!');
                return;
            } 
            if(!this.workOrder.assignee || !this.workOrder.assignee.id){
                alert('Assignee cannot be empty!');
                return;
            } 

            if(!this.workOrder.startDate){
                alert('Start Date cannot be empty!');
                return;
            } 
            if(!this.workOrder.plannedEndDate){
                alert('End Date cannot be empty!');
                return;
            } 
            if (this.$route.params.id != 'new') {        
                this.updateWorkOrder(this.workOrder);
            } else {
                this.addWorkOrder(this.workOrder);         
            }  
        },
        addWorkOrder(item){
            this.showProgress = true;
            this.$axios.post(this.$apiurl + WORK_ORDER_API_URL, {
                saleId: item.sale.id,  
                assigneeId: item.assignee.id,
                startDate: item.startDate,
                plannedEndDate: item.plannedEndDate,
                explanation: item.explanation
            })
            .then(response => {        
                if (response.status === 201) {
                    console.log(response.data);
                    this.workOrder = response.data;
                    //this.updateBreadCrumbs(response.data);
                    this.showProgress = false;
                    this.$radio.$emit('success', {message:'Work Order Created Successfully'});
                    //this.$router.push('/workOrders/'+this.workOrder.id);
                } 
            }) 
            .catch(error => {
                console.log(error);
            }); 
        },
        updateWorkOrderStatus(status){
            this.$axios.post(this.$apiurl + WORK_ORDER_API_URL+'/'+this.$route.params.id+'/status/'+status, {})
            .then(response => {        
                if (response.status === 200) {
                } 
            }) 
            .catch(error => {
                console.log(error);
            }); 
            },
        async addMaterial(workOrder){
            await this.$axios.post(this.$apiurl + WORK_ORDER_API_URL+'/'+this.$route.params.id+'/materials', {
                materialId: this.newMaterial.material.id,        
                price: this.newMaterial.price ? this.newMaterial.price : 0,
                quantity: this.newMaterial.quantity ? this.newMaterial.quantity : 1
            })
            .then(response => {        
                if (response.status === 201) {
                    this.$radio.$emit('success', {message:'Material Added Sucessfully'});
                } 
            }) 
            .catch(error => {
                console.log(error);
            });      
            this.newMaterial = {};  
        },
        updateWorkOrder(item){
            this.$axios.put(this.$apiurl + WORK_ORDER_API_URL, {
                id: item.id,
                supplierId: item.supplier.id,  
                currencyId: item.currency.id,
                startDate: item.startDate,
                status: item.status,
                explanation: item.explanation,
                materials: item.materials
            })
            .then(response => {
                if (response.status === 200) {
                    this.$radio.$emit('success', {message:'Work Order Saved Sucessfully'});
                }         
            }) 
            .catch(error => {
                console.log(error);
            }); 
        },
        async getWorkOrderDeliveries(){  
            this.workOrder.deliveries = [];
            
            await this.$axios.get(this.$apiurl + WORK_ORDER_API_URL+'/'+this.$route.params.id+'/deliveries')
            .then(response => {
                if(response.data && response.data.length>0){
                    this.workOrder.deliveries = response.data;  
                    //console.log(this.workOrder.deliveries);
                }
            }) 
            .catch(error => {
                console.log(error);
            });   
        },
        getMaterialList(){     
            this.$axios.get(this.$apiurl + MATERIALS_API_URL )
                .then(response => {
                    this.materialList = response.data;                          
                }) 
                .catch(error => {
                    console.log(error);
                });                         
        }, 
        materialSelected(item){  
            this.newMaterial.quantity = 1;
            this.newMaterial.price = 0;
        },
        updateBreadCrumbs(item){
            let workOrderText = 'Work Order ' + item.id;
            let saleIdText = item.saletext+'';
            
            breadcrumbs.dispatch('setBreadCrumps', [
                                      { text: 'Sales', disabled: false, href: '/#/sales'},
                                      { text: saleIdText , disabled: false, href: '/#/sales/'+item.sale.id},
                                      { text: workOrderText, disabled: true } // placeholder
                                  ]);
        },
        async deleteMaterial(item){                  
            if(confirm('Are you sure you want to delete this material?')){ 
                await this.$axios.delete(this.$apiurl + WORK_ORDER_API_URL+'/'+ this.$route.params.id +'/materials/'+item.id)
                .then(response => {        
                if (response.status === 200) {
                    this.$radio.$emit('success', {message:'Material Deleted Successfully'});
                } 
                }) 
                .catch(error => {
                console.log(error);
                });                         
            }     
        },
        getPersonnels(){     
            this.$axios.get(this.$apiurl + PERSONNEL_API_URL)
                .then(response => {
                    this.personnels = response.data
                }) 
                .catch(error => {
                    console.log(error);
                });                         
        },
    }
}
</script>